import React from 'react'
import { Button, Icon } from 'antd-mobile'
import './index.scss'

interface Props {
  closeFun: any
  desc: string
  confirmText: string
  confirmFun: any
}

const RatingFiveModal: React.FC<Props> = ({ closeFun, desc, confirmText, confirmFun }) => {
  return (
    <div className='c-rating-five-modal'>
      <div className='mask-layer'>
        <span className='btn-close' onClick={closeFun}>
          <Icon type='cross-circle' size='md' color='#fff' />
        </span>
        <div className='modal-content'>
          <div className='modal-header' />
          <div className='modal-body'>
            <div className='desc'>{desc}</div>
            <div className='star'>
              <span className='star-item' />
              <span className='star-item' />
              <span className='star-item' />
              <span className='star-item' />
              <span className='star-item' />
            </div>
          </div>
          <div className='modal-footer'>
            <Button className='btn btn-confirm' onClick={confirmFun}>
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RatingFiveModal
